import { Routes } from '@angular/router';
import { posAuthGuard } from './core/guards/auth.guard';
import { emailVerificationGuard } from './core/guards/email-verification.guard';
import { tenantGuard, locationGuard } from '@pos-shared';
import { authResolver } from './core/resolvers/auth.resolver';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./views/pages/login/login.component')
      .then(m => m.LoginComponent)
  },
  {
    path: 'register',
    loadComponent: () => import('./views/pages/register/register.component')
      .then(m => m.RegisterComponent)
  },
  {
    path: 'verify-email-pending',
    loadComponent: () => import('./views/pages/verify-email-pending/verify-email-pending.component')
      .then(m => m.VerifyEmailPendingComponent),
    resolve: { auth: authResolver },
    canActivate: [posAuthGuard]
  },
  {
    path: 'onboarding',
    loadComponent: () => import('./views/pages/onboarding/onboarding.component')
      .then(m => m.OnboardingComponent),
    resolve: { auth: authResolver },
    canActivate: [posAuthGuard]
  },
  {
    path: 'select-location',
    loadComponent: () => import('./views/pages/select-location/select-location.component')
      .then(m => m.SelectLocationComponent),
    resolve: { auth: authResolver },
    canActivate: [posAuthGuard, tenantGuard]
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./views/pages/unauthorized/unauthorized.component')
      .then(m => m.UnauthorizedComponent)
  },
  {
    path: '',
    loadComponent: () => import('./views/pages/pos-layout/pos-layout.component')
      .then(m => m.PosLayoutComponent),
    resolve: { auth: authResolver },
    canActivate: [posAuthGuard, emailVerificationGuard, tenantGuard, locationGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./views/pages/checkout/checkout.component')
          .then(m => m.CheckoutComponent)
      },
      {
        path: 'transactions',
        loadComponent: () => import('./views/pages/transactions/transactions.component')
          .then(m => m.TransactionsComponent)
      },
      {
        path: 'z-report',
        loadComponent: () => import('./views/pages/z-report/z-report.component')
          .then(m => m.ZReportComponent)
      }
    ]
  }
];
